import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { GalleryBlockEntry } from "../../blocks/toolboxComponentsMap";

/**
 * sealy ProductLineCollectionPage HERO gallery assembly (#33285), rendered
 * inside the full-document ProductLineCollectionPage. FAITHFUL port
 * of the first legacy `cms/product_line_collection_page.html` loop (verified
 * at git dev):
 *
 *     {% for block in self.modules %}
 *         {% if block.block_type == "gallery_block" %}
 *             <div class="block-{{ block.block_type }}">
 *                 {% include_block block %}
 *             </div>
 *         {% endif %}
 *     {% endfor %}
 *
 * i.e. ONLY top-level `gallery_block` modules, each hand-wrapped in
 * `<div class="block-gallery_block">` (load-bearing: the sealy
 * `_gallery-block.scss` sets its width). The legacy `include_block` ran
 * `GalleryBlock.get_context` -> `build_gallery_block_ssr_context` with the
 * PAGE in context, so the initial gallery index used the full page-priority
 * chain (URL `initial_variant_id` -> block `initial_variant` FK -> page
 * `initial_variant` FK). This is the page's MAIN product gallery, so that
 * page-aware index is reproduced exactly: it is threaded per block id through
 * the `gallery_ssr` side-channel (`get_pdp_block_ssr`, the same mechanism as
 * the body side-channels) and overrides the serialized page-independent
 * `initial_gallery_index` in `GalleryBlockEntry`.
 *
 * All other modules render in the separate ProductLineCollectionBody
 * assembly below the configurator chrome.
 */
export const ProductLineCollectionHeroGallery = (
    props: Immutable<
        Pick<
            templates.ProductLineCollectionPageTemplate,
            "page" | "gallery_ssr"
        >
    >,
): React.JSX.Element | null => {
    const modules = props.page.modules;
    if (!modules) {
        return null;
    }
    return (
        <>
            {modules.value.map((block) =>
                block.type === "gallery_block" ? (
                    <div key={block.id} className={`block-${block.type}`}>
                        <GalleryBlockEntry
                            value={block.value}
                            initialGalleryIndex={props.gallery_ssr[block.id]}
                        />
                    </div>
                ) : null,
            )}
        </>
    );
};
